import React from 'react';
import { FormattedMessage } from 'react-intl';
import { toast, ToastId } from 'react-toastify';

import {
    DownloadOptions,
    IToastService,
    ToastActionOptions,
} from '../../Core/Services/Interfaces/IToastService';
import { CustomDownloadToast } from '../Components/Views/CustomDownloadToast/CustomDownloadToast';
import { CustomToast, CustomToastType } from '../../Web/Components/Views/CustomToast/CustomToast';

class ToastService implements IToastService {
    public showSuccess(content: string): ToastId {
        return toast.success(CustomToast({ type: CustomToastType.SUCCESS, content }));
    }
    public showError(content: string, actionOptions?: ToastActionOptions): ToastId {
        return toast.error(CustomToast({ type: CustomToastType.ERROR, content, actionOptions }));
    }

    public showInfo(content: string, actionOptions?: ToastActionOptions): ToastId {
        return toast.info(CustomToast({ type: CustomToastType.INFO, content, actionOptions }));
    }

    public showSuccessUpdate(): ToastId {
        return toast(
            CustomToast({
                type: CustomToastType.SUCCESS,
                content: <FormattedMessage id="Toast_GenericSuccessUpdateData" />,
            })
        );
    }

    //* CUSTOM DOWNLOAD TOAST
    public showDownloadInfo(downloadOptions: DownloadOptions): ToastId {
        const toastContent = CustomDownloadToast({ downloadOptions });
        const toastId = toast.info(toastContent, {
            autoClose: false,
        });
        return toastId;
    }

    public updateDownloadInfo(toastId: ToastId, downloadOptions: DownloadOptions): ToastId {
        const toastContent = CustomDownloadToast({ downloadOptions });
        toast.update(toastId, { render: toastContent });
        return toastId;
    }

    public notImplemented(): ToastId {
        return this.showInfo('Not implemented yet');
    }

    public dismiss(toastId: ToastId): void {
        toast.dismiss(toastId);
    }
}

export { ToastService };
